<template>
  <section>
    <div class="prizes_header row">
      <div class="col-5 island-l"></div>
      <div class="col-2 prize_badge"></div>
      <div class="col-5 island-r"></div>
      <div class="col-12 prizes_title">{{ getTranslations.visitor_prizes_title_prizes }}</div>
    </div>

    <visitor-prizes-carousel></visitor-prizes-carousel>

    <div class="row prizes_rewards_banner">
      <div class="col-md-12">{{ getTranslations.visitor_prizes_instant_rewards }}</div>
    </div>


    <div class="prizes_tabset row">
      <input type="radio" name="tabset" id="tab1" aria-controls="memory_wizard" checked>
      <!-- add checked attribute to the selected input -->
      <label for="tab1">
        <img class="prizes_tab_logo" src="static/images/logo-memory-wizard.png"/>
      </label>
      <input type="radio" name="tabset" id="tab2" aria-controls="spot_difference">
      <label for="tab2">
        <img class="prizes_tab_logo" src="static/images/logo-spot-difference.png"/>
      </label>
      <input type="radio" name="tabset" id="tab3" aria-controls="odd_object">
      <label for="tab3">
        <img class="prizes_tab_logo" src="static/images/logo-odd-object.png"/>
      </label>

      <div class="tab-panels">
        <section id="memory_wizard" class="tab-panel">
          <div class="row gamepage_header">
            <img class="gamepage_logo " src="static/images/logo-memory-wizard.png">
            <h1>{{ getTranslations.visitor_prizes_mw }}</h1>
            <ul class="prizes_list">
              <li v-for="(prize, index) in memoryWizardPrizes" :key="index">
                <div class="row">
                  <div class="col-3">
                    <img class="prizes_won_list_image" :src="prize.imageUrl"></div>
                  <div class="col-9 profile_prize_cell">
                    <span class="prizes_prize_description">{{ prize.name }}</span>
                    <span class="prizes_prize_description_date" v-if="!ishidePrizeDescription">{{ prize.quantity }} {{ translationPerQuantity(prize.quantity) }}
                      {{ translationPerType(prize.type) }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section id="spot_difference" class="tab-panel">
          <div class="row gamepage_header">
            <img class="gamepage_logo " src="static/images/logo-spot-difference.png">
            <h1>{{ getTranslations.visitor_prizes_sd }}</h1>
            <ul class="prizes_list">
              <li v-for="(prize, index) in spotDifferencePrizes" :key="index">
                <div class="row">
                  <div class="col-3">
                    <img class="prizes_won_list_image" :src="prize.imageUrl"></div>
                  <div class="col-9 profile_prize_cell">
                    <span class="prizes_prize_description">{{ prize.name }}</span>
                    <span class="prizes_prize_description_date" v-if="!ishidePrizeDescription">{{ prize.quantity }} {{ translationPerQuantity(prize.quantity) }}
                      {{ translationPerType(prize.type) }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section id="odd_object" class="tab-panel">
          <div class="row gamepage_header">
            <img class="gamepage_logo " src="static/images/logo-odd-object.png">
            <h1>{{ getTranslations.visitor_prizes_odd }}</h1>
            <ul class="prizes_list">
              <li v-for="(prize, index) in oddObjectPrizes" :key="index">
                <div class="row">
                  <div class="col-3">
                    <img class="prizes_won_list_image" :src="prize.imageUrl"></div>
                  <div class="col-9 profile_prize_cell">
                    <span class="prizes_prize_description">{{ prize.name }}</span>
                    <span class="prizes_prize_description_date" v-if="!ishidePrizeDescription">{{ prize.quantity }} {{ translationPerQuantity(prize.quantity) }}
                      {{ translationPerType(prize.type) }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import VisitorPrizesCarousel from './visitor/VisitorPrizesCarousel';


export default {
  name: 'prizes',
  components: {
    VisitorPrizesCarousel,
  },
  mixins: [IntegrationMixin],
  data() {
    return {
      ishidePrizeDescription: null,
    };
  },
  created() {
    this.ishidePrizeDescription = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.hidePrizesDescription;
  },
  methods: {
    translationPerQuantity(quantity) { // different method from translationPerType due to AR css
      return (quantity) > 1 ? this.getTranslations.visitor_prizes_winners_per : this.getTranslations.visitor_prizes_winner_per;
    },
    translationPerType(type) {
      if (type === this.prizeType.daily) return this.getTranslations.visitor_prizes_winners_per_day;
      if (type === this.prizeType.weekly) return this.getTranslations.visitor_prizes_winners_per_week;
      if (type === this.prizeType.monthly) return this.getTranslations.visitor_prizes_winners_per_month;
      return '';
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'spotDifferencePrizes',
      'oddObjectPrizes',
      'memoryWizardPrizes',
    ]),
    ...mapState('common', [
      'prizeType',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Prizes.vue